module.exports = __webpack_public_path__ + "img/section2Logo7.ed74a947.png";